<div id="frame-wrapper">
    <iframe src="assets/htmls/fitnessfactory/mount-olive/webpage.html" width="100%"></iframe>
</div>